import { render } from "./AppContent.vue?vue&type=template&id=35684f3d"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__